export default "__VITE_ASSET__cgz0ZWSa__"